import { render, staticRenderFns } from "./BookingDiscounts.vue?vue&type=template&id=0dce135b&"
import script from "./BookingDiscounts.vue?vue&type=script&lang=js&"
export * from "./BookingDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports